import React, { useState, useEffect } from "react";
import { useUser } from "../contexts/UserContext";

function NetIdInput({ onSubmit }) {
  const [netId, setNetId] = useState("");
  const [error, setError] = useState("");
  const { user } = useUser();

  useEffect(() => {
    // Set netId from user context if available
    if (user && user.net_id) {
      setNetId(user.net_id);
    }
  }, [user]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Simple validation
    if (!netId.trim()) {
      setError("Please enter your NetID");
      return;
    }

    // Additional validation could be added here
    // For example, check if it matches a specific pattern

    onSubmit(netId.trim());
  };

  return (
    <div className="netid-container">
      <div className="netid-form-card">
        <h2>Welcome to SQL Assessment</h2>
        <p>Please confirm your NetID to begin:</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={netId}
            onChange={(e) => setNetId(e.target.value)}
            placeholder="NetID"
            className="netid-input"
          />

          {error && <div className="netid-error">{error}</div>}

          <button type="submit" className="netid-submit-btn">
            Start Assessment
          </button>
        </form>
      </div>
    </div>
  );
}

export default NetIdInput;
